import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=671bde1e&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=671bde1e&prod&lang=scss&scoped=true"
import style1 from "./AccountMenu.vue?vue&type=style&index=1&id=671bde1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bde1e",
  null
  
)

export default component.exports